module.exports = __webpack_public_path__ + "static/media/neha_profile.bad4a0ef.png";